import { AtlassianSupportsUkraineRouteHandler } from '@atlassian/mpac-primitives';
import { log } from '@atlassian/mpac-utils';
import React from 'react';
import { RedirectToLogin } from '../Redirect';
import { useLocationHref } from '../Router';
import { jsx as _jsx } from "react/jsx-runtime";
export const APOLLO_GRAPHQL_APIS_POSSIBLE_ERRORS = {
  RUBY_ACCESS_DENIED: 'ruby_region_access_denied',
  AUTH_FAILURE: 'auth_failure',
  SERVER_ERROR: 'server_error'
};
const isRuByRegionAccessDeniedError = error => {
  var _graphQLErrors$0$exte;
  const {
    graphQLErrors
  } = error;
  if (!(graphQLErrors !== null && graphQLErrors !== void 0 && graphQLErrors.length)) return false;
  return ((_graphQLErrors$0$exte = graphQLErrors[0].extensions) === null || _graphQLErrors$0$exte === void 0 ? void 0 : _graphQLErrors$0$exte.errorType) === APOLLO_GRAPHQL_APIS_POSSIBLE_ERRORS.RUBY_ACCESS_DENIED;
};
export const ApolloErrorHandler = _ref => {
  let {
    error,
    context,
    renderError,
    nonServerErrorCallback
  } = _ref;
  /**
   * When a logged-in users' session expires, the gateway treats it as failed-auth instead of
   * downgrading it to an unauthenticated call. Temporarily, we will redirect 401 responses
   * to the login page, for the app listing page.
   * See https://ecosystem.atlassian.net/browse/MC-1770
   */
  const locationHref = useLocationHref();
  if (error.networkError && 'statusCode' in error.networkError && error.networkError.statusCode === 401) {
    log.info("".concat(context.page), "Auth failure while executing ".concat(context.operationName, ", redirecting to login"));
    //Network error :401, redirect to login
    nonServerErrorCallback === null || nonServerErrorCallback === void 0 ? void 0 : nonServerErrorCallback({
      errorCode: 401,
      error
    });
    return /*#__PURE__*/_jsx(RedirectToLogin, {});
  }
  if (isRuByRegionAccessDeniedError(error)) {
    log.info("".concat(context.page), "Prevented Access to RuBy partner App, ".concat(context.operationName, ", ").concat(locationHref));
    //Network error :403, redirect to AtlassianSupportsUkraineRoute
    nonServerErrorCallback === null || nonServerErrorCallback === void 0 ? void 0 : nonServerErrorCallback({
      errorCode: 403,
      error
    });
    return /*#__PURE__*/_jsx(AtlassianSupportsUkraineRouteHandler, {});
  }
  return renderError(APOLLO_GRAPHQL_APIS_POSSIBLE_ERRORS.SERVER_ERROR, error);
};